import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Button } from '../button/button';
import { GuardrailDefinition, ThresholdLevel } from '../../../core/services/guardrail-config';

@Component({
  selector: 'app-guardrail-config-modal',
  standalone: true,
  imports: [CommonModule, FormsModule, Button],
  templateUrl: './guardrail-config-modal.html',
  styleUrl: './guardrail-config-modal.css'
})
export class GuardrailConfigModal implements OnChanges {
  @Input({ required: true }) guardrail!: GuardrailDefinition;
  @Output() closed = new EventEmitter<void>();
  @Output() saved = new EventEmitter<GuardrailDefinition>();

  draft!: GuardrailDefinition;
  thresholds: ThresholdLevel[] = ['Low', 'Medium', 'High'];
  newUrl = '';

  ngOnChanges(changes: SimpleChanges) {
    if (changes['guardrail']) {
      this.draft = JSON.parse(JSON.stringify(this.guardrail));
    }
  }

  toggleEnabled() {
    this.draft.enabled = !this.draft.enabled;
  }

  toggleOption(groupId: string, optionId: string) {
    const group = this.draft.groups?.find(g => g.id === groupId);
    const option = group?.options.find(o => o.id === optionId);
    if (option) option.checked = !option.checked;
  }

  isGroupAllChecked(groupId: string): boolean {
    const group = this.draft.groups?.find(g => g.id === groupId);
    return !!group && group.options.every(o => o.checked);
  }

  toggleGroupAll(groupId: string) {
    const group = this.draft.groups?.find(g => g.id === groupId);
    if (!group) return;
    const nextState = !this.isGroupAllChecked(groupId);
    group.options.forEach(o => (o.checked = nextState));
  }

  selectedInGroup(groupId: string): number {
    return this.draft.groups?.find(g => g.id === groupId)?.options.filter(o => o.checked).length ?? 0;
  }

  totalSelected(): number {
    return (this.draft.groups ?? []).flatMap(g => g.options).filter(o => o.checked).length;
  }

  totalOptions(): number {
    return (this.draft.groups ?? []).flatMap(g => g.options).length;
  }

  setThreshold(level: ThresholdLevel) {
    this.draft.threshold = level;
  }

  addUrl() {
    const value = this.newUrl.trim();
    if (!value) return;
    this.draft.urlAllowList = Array.from(new Set([...(this.draft.urlAllowList ?? []), value]));
    this.newUrl = '';
  }

  removeUrl(url: string) {
    this.draft.urlAllowList = (this.draft.urlAllowList ?? []).filter(item => item !== url);
  }

  onOverlayClick() {
    this.closed.emit();
  }

  onSave() {
    this.saved.emit(this.draft);
  }

  onCancel() {
    this.closed.emit();
  }
}
